import React from 'react';
import { observer } from '../../shared/observer';
import { curFormat } from '../../shared/format';

class BonusesView extends React.Component {
  render() {
    const company = this.props.auth.companyInfo;
    const ci = this.props.auth.clientInfo || {};
    const cur = (company.currency_hash && company.currency_hash.symbol_html) || '';
    return (
      <div>
        <h1>Бонусы</h1>
        <div className="ng-bonus-card">
          <div className="ng-bonus-card__label">Ваш баланс</div>
          <div className="ng-bonus-card__value">{curFormat(ci.bonuses || 0)} {cur}</div>
          {company.bonus_total_percent > 0 && (
            <div className="ng-bonus-card__pct">+{company.bonus_total_percent}% с каждого заказа</div>
          )}
        </div>
        {company.bonus_info && (
          <div className="content-text">{company.bonus_info}</div>
        )}
      </div>
    );
  }
}

export const Bonuses = observer(BonusesView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/Bonuses.jsx